import React, { useState } from "react";

// ── Data ─────────────────────────────────────────────────────────────────────
const OPERATORS = [
  { name: "Jio",              code: "JIO",    type: "mobile",   color: "#185FA5" },
  { name: "Airtel",           code: "AT",     type: "mobile",   color: "#D85A30" },
  { name: "Vi (Vodafone Idea)",code:"VI",     type: "mobile",   color: "#534AB7" },
  { name: "BSNL Topup",       code: "BST",   type: "mobile",   color: "#3B6D11" },
  { name: "BSNL STV",         code: "BSS",   type: "mobile",   color: "#3B6D11" },
  { name: "MTNL Delhi",       code: "MTNLD", type: "mobile",   color: "#5F5E5A" },
  { name: "MTNL Mumbai",      code: "MTNLM", type: "mobile",   color: "#5F5E5A" },
  { name: "Tata Sky",         code: "TATSKY",type: "dth",      color: "#BA7517" },
  { name: "Airtel DTH",       code: "ATDTH", type: "dth",      color: "#D85A30" },
  { name: "Dish TV",          code: "DISH",  type: "dth",      color: "#185FA5" },
  { name: "Sun Direct",       code: "SUN",   type: "dth",      color: "#D85A30" },
  { name: "Videocon D2H",     code: "VD2H",  type: "dth",      color: "#534AB7" },
  { name: "DD Free Dish",     code: "DDFREE",type: "dth",      color: "#5F5E5A" },
  { name: "Jio Data",         code: "JIODC", type: "data",     color: "#185FA5" },
  { name: "Airtel Data",      code: "ATDC",  type: "data",     color: "#D85A30" },
  { name: "Vodafone Data",    code: "VIDC",  type: "data",     color: "#534AB7" },
  { name: "BSNL Data",        code: "BSNLDC",type: "data",     color: "#3B6D11" },
  { name: "Airtel Landline",  code: "ATLL",  type: "landline", color: "#D85A30" },
  { name: "BSNL Landline",    code: "BSNLLL",type: "landline", color: "#3B6D11" },
  { name: "MTNL Landline",    code: "MTNLLL",type: "landline", color: "#5F5E5A" },
  { name: "Jio Fiber",        code: "JIOF",  type: "landline", color: "#185FA5" },
];

const CIRCLES = [
  ["Andhra Pradesh","1"],["Assam","2"],["Bihar & Jharkhand","3"],["Chennai","4"],
  ["Delhi & NCR","5"],["Gujarat","6"],["Haryana","7"],["Himachal Pradesh","8"],
  ["J&K","9"],["Karnataka","10"],["Kerala","11"],["MP & Chhattisgarh","12"],
  ["Maharashtra","13"],["Mumbai","14"],["North East","15"],["Odisha","16"],
  ["Punjab","17"],["Rajasthan","18"],["Tamil Nadu","19"],["UP East","20"],
  ["UP West & Uttarakhand","21"],["West Bengal","22"],["Kolkata","23"],["All India","0"],
];

const NAV_ITEMS = [
  { id: "operators", label: "Operator codes",   color: "#185FA5", section: "Overview" },
  { id: "auth",      label: "Authentication",   color: "#5F5E5A", section: null },
  { id: "recharge",  label: "Recharge request", color: "#3B6D11", section: "Endpoints" },
  { id: "status",    label: "Status check",     color: "#BA7517", section: null },
  { id: "balance",   label: "Balance check",    color: "#534AB7", section: null },
  { id: "callback",  label: "Callback / webhook",color: "#D85A30",section: null },
  { id: "kyc",       label: "KYC Verification", color: "#3C3489", section: "KYC Endpoints" },
];

// ── Shared Components ─────────────────────────────────────────────────────────
const styles = {
  methodBadge: (method) => ({
    display: "inline-block",
    padding: "3px 9px",
    borderRadius: 6,
    fontSize: 11,
    fontWeight: 600,
    fontFamily: "monospace",
    background: method === "POST" ? "#EAF3DE" : "#E6F1FB",
    color: method === "POST" ? "#3B6D11" : "#0C447C",
  }),
  badge: (type) => ({
    display: "inline-block",
    padding: "1px 7px",
    borderRadius: 4,
    fontSize: 10,
    fontWeight: 600,
    background: type === "required" ? "#FCEBEB" : "#F1EFE8",
    color: type === "required" ? "#A32D2D" : "#5F5E5A",
  }),
  codeBlock: {
    background: "#F8FAFC",
    border: "0.5px solid #e2e8f0",
    borderRadius: 8,
    padding: "14px 16px",
    fontFamily: "monospace",
    fontSize: 12,
    lineHeight: 1.8,
    overflowX: "auto",
    position: "relative",
    whiteSpace: "pre",
  },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 12 },
  th: {
    padding: "8px 10px",
    textAlign: "left",
    background: "#f8fafc",
    color: "#64748b",
    fontWeight: 600,
    fontSize: 11,
    borderBottom: "0.5px solid #e2e8f0",
  },
  td: { padding: "9px 10px", borderBottom: "0.5px solid #f1f5f9", verticalAlign: "top" },
  noteBox: (color = "#BA7517") => ({
    background: color === "#BA7517" ? "#FAEEDA" : color === "#185FA5" ? "#E6F1FB" : "#FCEBEB",
    borderLeft: `3px solid ${color}`,
    padding: "10px 14px",
    fontSize: 12,
    color: color === "#BA7517" ? "#633806" : color === "#185FA5" ? "#0C447C" : "#A32D2D",
    marginBottom: 16,
  }),
};

function CopyButton({ getText }) {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText(getText()).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };
  return (
    <button
      onClick={copy}
      style={{
        position: "absolute", top: 8, right: 8,
        padding: "3px 10px", background: "#fff",
        border: "0.5px solid #e2e8f0", borderRadius: 6,
        fontSize: 11, cursor: "pointer", color: "#64748b",
      }}
    >
      {copied ? "Copied!" : "Copy"}
    </button>
  );
}

function CodeBlock({ code }) {
  const colored = code
    .replace(/"([^"]+)"(?=\s*:)/g, (_, k) => `<span style="color:#185FA5">"${k}"</span>`)
    .replace(/:\s*"([^"]*)"/g, (_, v) => `: <span style="color:#3B6D11">"${v}"</span>`)
    .replace(/:\s*(true|false)/g, (_, v) => `: <span style="color:#534AB7">${v}</span>`)
    .replace(/:\s*(\d+)/g, (_, v) => `: <span style="color:#D85A30">${v}</span>`);
  return (
    <div style={styles.codeBlock}>
      <CopyButton getText={() => code} />
      <div dangerouslySetInnerHTML={{ __html: colored }} />
    </div>
  );
}

function SectionLabel({ children, style = {} }) {
  return (
    <div style={{
      fontSize: 11, fontWeight: 600, color: "#64748b",
      letterSpacing: ".06em", textTransform: "uppercase",
      marginBottom: 10, marginTop: 20, ...style,
    }}>
      {children}
    </div>
  );
}

function BaseUrl({ method, path }) {
  return (
    <div style={{
      display: "inline-flex", alignItems: "center", gap: 10,
      background: "#f8fafc", border: "0.5px solid #e2e8f0",
      borderRadius: 8, padding: "8px 14px",
      fontFamily: "monospace", fontSize: 12, marginTop: 10,
    }}>
      <span style={styles.methodBadge(method)}>{method}</span>
      <span style={{ color: "#64748b" }}>https://api.mokshiq.in/</span>
      <span style={{ color: "#185FA5", fontWeight: 600 }}>{path}</span>
    </div>
  );
}

function ParamRow({ name, type, required, desc }) {
  return (
    <tr>
      <td style={styles.td}>
        <span style={{ fontFamily: "monospace", fontSize: 12, color: "#185FA5" }}>{name}</span>
      </td>
      <td style={styles.td}><span style={{ color: "#64748b" }}>{type}</span></td>
      <td style={styles.td}>
        <span style={styles.badge(required ? "required" : "optional")}>
          {required ? "required" : "optional"}
        </span>
      </td>
      <td style={{ ...styles.td, color: "#374151" }}>{desc}</td>
    </tr>
  );
}

function TabPanel({ tabs }) {
  const [active, setActive] = useState(0);
  return (
    <div>
      <div style={{ display: "flex", gap: 2, borderBottom: "0.5px solid #e2e8f0", marginBottom: 14 }}>
        {tabs.map((t, i) => (
          <button
            key={i}
            onClick={() => setActive(i)}
            style={{
              padding: "7px 14px", fontSize: 12, cursor: "pointer",
              border: "none", background: "transparent",
              borderBottom: `2px solid ${active === i ? "#185FA5" : "transparent"}`,
              color: active === i ? "#185FA5" : "#64748b",
              fontWeight: active === i ? 600 : 400,
              marginBottom: -1,
            }}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tabs[active].content}
    </div>
  );
}

// ── Pages ─────────────────────────────────────────────────────────────────────
function OperatorsPage() {
  const [filter, setFilter] = useState("all");
  const filters = ["all", "mobile", "dth", "data", "landline"];
  const filtered = filter === "all" ? OPERATORS : OPERATORS.filter(o => o.type === filter);

  return (
    <div>
      <div style={{ marginBottom: 24, paddingBottom: 16, borderBottom: "0.5px solid #e2e8f0" }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 4, color: "#0f172a" }}>Operator codes</h2>
        <p style={{ fontSize: 13, color: "#64748b" }}>
          Use these codes in the{" "}
          <code style={{ background: "#f1f5f9", padding: "1px 6px", borderRadius: 4, fontSize: 12 }}>operator_code</code>{" "}
          field of recharge requests.
        </p>
      </div>

      <div style={{ display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap" }}>
        {filters.map(f => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            style={{
              padding: "5px 14px", borderRadius: 20, fontSize: 12, cursor: "pointer",
              border: "0.5px solid",
              borderColor: filter === f ? "#185FA5" : "#e2e8f0",
              background: filter === f ? "#E6F1FB" : "#fff",
              color: filter === f ? "#0C447C" : "#64748b",
              fontWeight: filter === f ? 600 : 400,
            }}
          >
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 8, marginBottom: 24 }}>
        {filtered.map(op => (
          <div
            key={op.code}
            style={{
              background: "#fff", border: "0.5px solid #e2e8f0",
              borderRadius: 10, padding: "10px 12px",
              borderLeft: `3px solid ${op.color}`,
            }}
          >
            <div style={{ fontWeight: 600, fontSize: 13, color: "#0f172a", marginBottom: 2 }}>{op.name}</div>
            <div style={{ fontFamily: "monospace", fontSize: 11, color: op.color, fontWeight: 600 }}>{op.code}</div>
            <div style={{
              fontSize: 10, marginTop: 3, textTransform: "uppercase",
              letterSpacing: ".05em", color: "#94a3b8",
            }}>{op.type}</div>
          </div>
        ))}
      </div>

      <SectionLabel style={{ marginTop: 0 }}>Circle codes</SectionLabel>
      <div style={styles.noteBox("#BA7517")}>
        Circle code is required for prepaid mobile recharges. Use{" "}
        <code style={{ fontFamily: "monospace" }}>0</code> for DTH / data card / all-India plans.
      </div>
      <div style={{ border: "0.5px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Circle</th>
              <th style={styles.th}>Code</th>
              <th style={styles.th}>Circle</th>
              <th style={styles.th}>Code</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: Math.ceil(CIRCLES.length / 2) }, (_, i) => (
              <tr key={i}>
                <td style={styles.td}>{CIRCLES[i * 2]?.[0]}</td>
                <td style={{ ...styles.td, fontFamily: "monospace", color: "#185FA5", fontWeight: 600 }}>{CIRCLES[i * 2]?.[1]}</td>
                <td style={styles.td}>{CIRCLES[i * 2 + 1]?.[0]}</td>
                <td style={{ ...styles.td, fontFamily: "monospace", color: "#185FA5", fontWeight: 600 }}>{CIRCLES[i * 2 + 1]?.[1]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function AuthPage() {
  return (
    <div>
      <div style={{ marginBottom: 24, paddingBottom: 16, borderBottom: "0.5px solid #e2e8f0" }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 4, color: "#0f172a" }}>Authentication</h2>
        <p style={{ fontSize: 13, color: "#64748b" }}>All API requests must include your API key in the Authorization header.</p>
      </div>
      <SectionLabel style={{ marginTop: 0 }}>Request headers</SectionLabel>
      <div style={{ border: "0.5px solid #e2e8f0", borderRadius: 10, overflow: "hidden", marginBottom: 16 }}>
        <table style={styles.table}>
          <thead><tr><th style={styles.th}>Header</th><th style={styles.th}>Value</th><th style={styles.th}>Description</th></tr></thead>
          <tbody>
            <tr>
              <td style={styles.td}><span style={{ fontFamily: "monospace", fontSize: 12, color: "#185FA5" }}>Authorization</span></td>
              <td style={styles.td}><span style={{ fontFamily: "monospace", fontSize: 12, color: "#3B6D11" }}>Bearer YOUR_API_KEY</span></td>
              <td style={styles.td}>Your secret API key</td>
            </tr>
            <tr>
              <td style={{ ...styles.td, borderBottom: "none" }}><span style={{ fontFamily: "monospace", fontSize: 12, color: "#185FA5" }}>Content-Type</span></td>
              <td style={{ ...styles.td, borderBottom: "none" }}><span style={{ fontFamily: "monospace", fontSize: 12, color: "#3B6D11" }}>application/json</span></td>
              <td style={{ ...styles.td, borderBottom: "none" }}>Required for all POST requests</td>
            </tr>
          </tbody>
        </table>
      </div>
      <SectionLabel>Example</SectionLabel>
      <CodeBlock code={`Authorization: Bearer mk_live_xxxxxxxxxxxxxxxxxxxx\nContent-Type: application/json`} />
      <div style={{ ...styles.noteBox("#D85A30"), marginTop: 16 }}>
        Keep your API key secret. Never expose it in frontend code or public repositories.
      </div>
    </div>
  );
}

function RechargePage() {
  return (
    <div>
      <div style={{ marginBottom: 24, paddingBottom: 16, borderBottom: "0.5px solid #e2e8f0" }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 4, color: "#0f172a" }}>Recharge request</h2>
        <p style={{ fontSize: 13, color: "#64748b" }}>Initiate a mobile, DTH, or data card recharge for a customer.</p>
        <BaseUrl method="POST" path="recharge_request" />
      </div>

      <SectionLabel style={{ marginTop: 0 }}>Request parameters</SectionLabel>
      <div style={{ border: "0.5px solid #e2e8f0", borderRadius: 10, overflow: "hidden", marginBottom: 16 }}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Parameter</th>
              <th style={styles.th}>Type</th>
              <th style={styles.th}>Required</th>
              <th style={styles.th}>Description</th>
            </tr>
          </thead>
          <tbody>
            <ParamRow name="user_id"        type="string"  required desc="Your distributor / retailer user ID" />
            <ParamRow name="mobile_number"  type="string"  required desc="10-digit mobile or DTH subscriber ID" />
            <ParamRow name="operator_code"  type="string"  required desc="Operator code from the operator list (e.g. JIO, AT, DISH)" />
            <ParamRow name="circle_code"    type="integer" required desc="Circle code (use 0 for DTH / data card)" />
            <ParamRow name="amount"         type="number"  required desc="Recharge amount in INR" />
            <ParamRow name="recharge_type"  type="string"  required desc="P = Prepaid, D = DTH, DC = Data card" />
            <ParamRow name="client_ref_id"  type="string"  required desc="Unique reference ID from your system (for idempotency)" />
            <ParamRow name="pin"            type="string"  required desc="Transaction PIN" />
            <ParamRow name="callback_url"   type="string"  required={false} desc="Webhook URL to receive async status updates" />
          </tbody>
        </table>
      </div>

      <SectionLabel>Request body</SectionLabel>
      <CodeBlock code={`{
  "user_id": "USR001",
  "mobile_number": "9876543210",
  "operator_code": "JIO",
  "circle_code": 5,
  "amount": 239,
  "recharge_type": "P",
  "client_ref_id": "TXN20240502001",
  "pin": "1234",
  "callback_url": "https://yourdomain.com/callback"
}`} />

      <SectionLabel>Response</SectionLabel>
      <TabPanel tabs={[
        {
          label: "Success",
          content: (
            <div>
              <div style={{ background: "#EAF3DE", borderLeft: "3px solid #639922", padding: "8px 12px", fontSize: 12, color: "#3B6D11", marginBottom: 10 }}>HTTP 200 · status: true</div>
              <CodeBlock code={`{
  "status": true,
  "message": "Recharge successful",
  "data": {
    "txn_id": "MK20240502001234",
    "client_ref_id": "TXN20240502001",
    "operator_ref": "JIO9876543210",
    "mobile_number": "9876543210",
    "operator": "Jio",
    "amount": 239,
    "status": "success",
    "balance_before": 5000,
    "balance_after": 4761,
    "commission": 2.39,
    "created_at": "2024-05-02T10:30:00Z"
  }
}`} />
            </div>
          ),
        },
        {
          label: "Failure",
          content: (
            <div>
              <div style={{ background: "#FCEBEB", borderLeft: "3px solid #E24B4A", padding: "8px 12px", fontSize: 12, color: "#A32D2D", marginBottom: 10 }}>HTTP 200 · status: false</div>
              <CodeBlock code={`{
  "status": false,
  "message": "Insufficient wallet balance",
  "error_code": "ERR_LOW_BALANCE",
  "data": {}
}`} />
            </div>
          ),
        },
      ]} />
    </div>
  );
}

function StatusPage() {
  return (
    <div>
      <div style={{ marginBottom: 24, paddingBottom: 16, borderBottom: "0.5px solid #e2e8f0" }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 4, color: "#0f172a" }}>Status check</h2>
        <p style={{ fontSize: 13, color: "#64748b" }}>Check the current status of a previously submitted recharge transaction.</p>
        <BaseUrl method="POST" path="recharge_status" />
      </div>

      <SectionLabel style={{ marginTop: 0 }}>Request parameters</SectionLabel>
      <div style={{ border: "0.5px solid #e2e8f0", borderRadius: 10, overflow: "hidden", marginBottom: 8 }}>
        <table style={styles.table}>
          <thead><tr><th style={styles.th}>Parameter</th><th style={styles.th}>Type</th><th style={styles.th}>Required</th><th style={styles.th}>Description</th></tr></thead>
          <tbody>
            <ParamRow name="user_id"       type="string" required desc="Your distributor / retailer user ID" />
            <ParamRow name="txn_id"        type="string" required={false} desc="Transaction ID returned from recharge request" />
            <ParamRow name="client_ref_id" type="string" required={false} desc="Your reference ID sent during recharge" />
          </tbody>
        </table>
      </div>
      <div style={{ ...styles.noteBox("#185FA5"), marginBottom: 16 }}>
        At least one of <code style={{ fontFamily: "monospace" }}>txn_id</code> or <code style={{ fontFamily: "monospace" }}>client_ref_id</code> is required.
      </div>

      <SectionLabel>Request body</SectionLabel>
      <CodeBlock code={`{
  "user_id": "USR001",
  "txn_id": "MK20240502001234"
}`} />

      <SectionLabel>Response</SectionLabel>
      <TabPanel tabs={[
        {
          label: "Success",
          content: (
            <div>
              <div style={{ background: "#EAF3DE", borderLeft: "3px solid #639922", padding: "8px 12px", fontSize: 12, color: "#3B6D11", marginBottom: 10 }}>status: "success"</div>
              <CodeBlock code={`{
  "status": true,
  "message": "Transaction found",
  "data": {
    "txn_id": "MK20240502001234",
    "client_ref_id": "TXN20240502001",
    "mobile_number": "9876543210",
    "operator": "Jio",
    "amount": 239,
    "status": "success",
    "operator_ref": "JIO9876543210",
    "created_at": "2024-05-02T10:30:00Z",
    "updated_at": "2024-05-02T10:30:45Z"
  }
}`} />
            </div>
          ),
        },
        {
          label: "Pending",
          content: (
            <div>
              <div style={{ ...styles.noteBox("#185FA5"), marginBottom: 10 }}>status: "pending" — poll again after 30 seconds.</div>
              <CodeBlock code={`{
  "status": true,
  "data": {
    "txn_id": "MK20240502001234",
    "status": "pending",
    "created_at": "2024-05-02T10:30:00Z"
  }
}`} />
            </div>
          ),
        },
        {
          label: "Failed",
          content: (
            <div>
              <div style={{ background: "#FCEBEB", borderLeft: "3px solid #E24B4A", padding: "8px 12px", fontSize: 12, color: "#A32D2D", marginBottom: 10 }}>status: "failed" — amount refunded</div>
              <CodeBlock code={`{
  "status": true,
  "data": {
    "txn_id": "MK20240502001234",
    "status": "failed",
    "failure_reason": "Invalid mobile number",
    "refund_status": "refunded",
    "created_at": "2024-05-02T10:30:00Z"
  }
}`} />
            </div>
          ),
        },
      ]} />
    </div>
  );
}

function BalancePage() {
  return (
    <div>
      <div style={{ marginBottom: 24, paddingBottom: 16, borderBottom: "0.5px solid #e2e8f0" }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 4, color: "#0f172a" }}>Balance check</h2>
        <p style={{ fontSize: 13, color: "#64748b" }}>Retrieve the current wallet balance for your account.</p>
        <BaseUrl method="POST" path="check_balance" />
      </div>

      <SectionLabel style={{ marginTop: 0 }}>Request parameters</SectionLabel>
      <div style={{ border: "0.5px solid #e2e8f0", borderRadius: 10, overflow: "hidden", marginBottom: 16 }}>
        <table style={styles.table}>
          <thead><tr><th style={styles.th}>Parameter</th><th style={styles.th}>Type</th><th style={styles.th}>Required</th><th style={styles.th}>Description</th></tr></thead>
          <tbody>
            <ParamRow name="user_id" type="string" required desc="Your distributor / retailer user ID" />
            <ParamRow name="pin"     type="string" required desc="Transaction PIN for authentication" />
          </tbody>
        </table>
      </div>

      <SectionLabel>Request body</SectionLabel>
      <CodeBlock code={`{
  "user_id": "USR001",
  "pin": "1234"
}`} />

      <SectionLabel>Response</SectionLabel>
      <CodeBlock code={`{
  "status": true,
  "message": "Balance fetched successfully",
  "data": {
    "user_id": "USR001",
    "wallet_balance": 4761.00,
    "credit_limit": 0,
    "total_available": 4761.00,
    "currency": "INR",
    "last_updated": "2024-05-02T10:31:00Z"
  }
}`} />
    </div>
  );
}

function CallbackPage() {
  return (
    <div>
      <div style={{ marginBottom: 24, paddingBottom: 16, borderBottom: "0.5px solid #e2e8f0" }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 4, color: "#0f172a" }}>Callback / webhook</h2>
        <p style={{ fontSize: 13, color: "#64748b" }}>
          When a{" "}
          <code style={{ background: "#f1f5f9", padding: "1px 6px", borderRadius: 4, fontSize: 12 }}>callback_url</code>{" "}
          is provided, the API sends a POST to your endpoint once the transaction status is final.
        </p>
      </div>

      <div style={styles.noteBox("#BA7517")}>
        Your endpoint must return HTTP <code style={{ fontFamily: "monospace" }}>200 OK</code> within 5 seconds.
        If it does not, the callback is retried up to 3 times with 60-second intervals.
      </div>

      <SectionLabel style={{ marginTop: 0 }}>Callback payload</SectionLabel>
      <CodeBlock code={`{
  "event": "recharge.status_update",
  "txn_id": "MK20240502001234",
  "client_ref_id": "TXN20240502001",
  "mobile_number": "9876543210",
  "operator_code": "JIO",
  "operator_ref": "JIO9876543210",
  "amount": 239,
  "status": "success",
  "commission": 2.39,
  "timestamp": "2024-05-02T10:30:45Z",
  "signature": "sha256_hmac_signature"
}`} />

      <SectionLabel>Transaction status values</SectionLabel>
      <div style={{ border: "0.5px solid #e2e8f0", borderRadius: 10, overflow: "hidden", marginBottom: 16 }}>
        <table style={styles.table}>
          <thead><tr><th style={styles.th}>Status</th><th style={styles.th}>Meaning</th></tr></thead>
          <tbody>
            {[
              ["success", "#EAF3DE", "#3B6D11", "Recharge completed successfully"],
              ["pending", "#FAEEDA", "#633806", "Processing — callback fires again when final"],
              ["failed",  "#FCEBEB", "#A32D2D", "Recharge failed — amount refunded to wallet"],
              ["refunded","#EEEDFE", "#3C3489", "Amount reversed to wallet"],
            ].map(([s, bg, c, desc]) => (
              <tr key={s}>
                <td style={styles.td}>
                  <span style={{ background: bg, color: c, padding: "2px 9px", borderRadius: 4, fontSize: 11, fontWeight: 600 }}>{s}</span>
                </td>
                <td style={{ ...styles.td, color: "#374151" }}>{desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <SectionLabel>Signature verification (Node.js)</SectionLabel>
      <CodeBlock code={`const crypto = require('crypto');

function verifySignature(payload, signature, secret) {
  const expected = crypto
    .createHmac('sha256', secret)
    .update(JSON.stringify(payload))
    .digest('hex');
  return crypto.timingSafeEqual(
    Buffer.from(expected),
    Buffer.from(signature)
  );
}`} />

      <SectionLabel>Your callback endpoint must respond</SectionLabel>
      <CodeBlock code={`HTTP/1.1 200 OK
Content-Type: application/json

{ "received": true }`} />
    </div>
  );
}

const KYC_TYPES = [
  { type: "PANCARD", desc: "PAN Card verification" },
  { type: "PAN_LITE", desc: "PAN Lite verification" },
  { type: "AADHAAR", desc: "Aadhaar OTP-based verification" },
  { type: "BANK_ACCOUNT", desc: "Bank account verification" },
  { type: "ACCOUNT VERIFICATION", desc: "Account verification" },
  { type: "GST", desc: "GST number verification" },
  { type: "GSTIN", desc: "GSTIN verification" },
  { type: "PANTOGST", desc: "PAN to GST lookup" },
  { type: "PAN_GSTIN", desc: "PAN to GSTIN lookup" },
  { type: "PAN_UDYAM", desc: "PAN to Udyam lookup" },
  { type: "UDYAM", desc: "Udyam number verification" },
  { type: "CIN", desc: "Company CIN verification" },
  { type: "DRIVING LICENCE", desc: "Driving licence verification" },
  { type: "VOTERID", desc: "Voter ID verification" },
  { type: "PASSPORT", desc: "Passport verification" },
  { type: "VEHICLE_RC", desc: "Vehicle RC verification" },
  { type: "FACE_MATCH", desc: "Face match (multipart/image)" },
  { type: "MOBILE_PENNYDROP", desc: "Mobile UPI penny drop" },
  { type: "AADHAAR_MASKING", desc: "Aadhaar masking (multipart/image)" }
];

const KYC_SECTIONS = [
  {
    title: "PAN / PAN_LITE",
    curl: `curl -X POST "https://yourdomain.com/api/kyc-verify/" \\
  -H "Content-Type: application/json" \\
  -d '{
    "user_id": 101,
    "pin": "1234",
    "kyc_type": "PANCARD",
    "amount": "10",
    "pan_number": "ABCDE1234F",
    "name": "John Doe",
    "dob": "1990-01-15"
  }'`,
    params: [
      { name: "pan_number", type: "string", req: "required" },
      { name: "name", type: "string", req: "optional" },
      { name: "dob", type: "string YYYY-MM-DD", req: "optional" }
    ]
  },
  {
    title: "AADHAAR",
    curl: `curl -X POST "https://yourdomain.com/api/kyc-verify/" \\
  -H "Content-Type: application/json" \\
  -d '{
    "user_id": 101,
    "pin": "1234",
    "kyc_type": "AADHAAR",
    "amount": "15",
    "aadhaar_number": "123456789012"
  }'`,
    params: [
      { name: "aadhaar_number", type: "string", req: "required" }
    ]
  },
  {
    title: "BANK_ACCOUNT / ACCOUNT VERIFICATION",
    curl: `curl -X POST "https://yourdomain.com/api/kyc-verify/" \\
  -H "Content-Type: application/json" \\
  -d '{
    "user_id": 101,
    "pin": "1234",
    "kyc_type": "BANK_ACCOUNT",
    "amount": "5",
    "account_number": "9876543210",
    "ifsc_code": "SBIN0001234"
  }'`,
    params: [
      { name: "account_number", type: "string", req: "required" },
      { name: "ifsc_code", type: "string", req: "required" }
    ]
  },
  {
    title: "GST / GSTIN",
    curl: `curl -X POST "https://yourdomain.com/api/kyc-verify/" \\
  -H "Content-Type: application/json" \\
  -d '{
    "user_id": 101,
    "pin": "1234",
    "kyc_type": "GSTIN",
    "amount": "15",
    "gstin": "07AAAAA1111A1Z1"
  }'`,
    params: [
      { name: "gstin", type: "string", req: "required" }
    ]
  },
  {
    title: "PANTOGST / PAN_GSTIN / PAN_UDYAM",
    curl: `curl -X POST "https://yourdomain.com/api/kyc-verify/" \\
  -H "Content-Type: application/json" \\
  -d '{
    "user_id": 101,
    "pin": "1234",
    "kyc_type": "PAN_GSTIN",
    "amount": "12",
    "pan_number": "ABCDE1234F"
  }'`,
    params: [
      { name: "pan_number", type: "string", req: "required" }
    ]
  },
  {
    title: "UDYAM",
    curl: `curl -X POST "https://yourdomain.com/api/kyc-verify/" \\
  -H "Content-Type: application/json" \\
  -d '{
    "user_id": 101,
    "pin": "1234",
    "kyc_type": "UDYAM",
    "amount": "15",
    "udyam_number": "UDYAM-DL-00-1234567"
  }'`,
    params: [
      { name: "udyam_number", type: "string", req: "required" }
    ]
  },
  {
    title: "CIN",
    curl: `curl -X POST "https://yourdomain.com/api/kyc-verify/" \\
  -H "Content-Type: application/json" \\
  -d '{
    "user_id": 101,
    "pin": "1234",
    "kyc_type": "CIN",
    "amount": "20",
    "cin": "U74900DL2015PTC288000"
  }'`,
    params: [
      { name: "cin", type: "string", req: "required" }
    ]
  },
  {
    title: "DRIVING LICENCE",
    curl: `curl -X POST "https://yourdomain.com/api/kyc-verify/" \\
  -H "Content-Type: application/json" \\
  -d '{
    "user_id": 101,
    "pin": "1234",
    "kyc_type": "DRIVING LICENCE",
    "amount": "10",
    "dl_number": "DL-1420110012345",
    "dob": "1990-01-15"
  }'`,
    params: [
      { name: "dl_number", type: "string", req: "required" },
      { name: "dob", type: "string YYYY-MM-DD", req: "required" }
    ]
  },
  {
    title: "VOTERID",
    curl: `curl -X POST "https://yourdomain.com/api/kyc-verify/" \\
  -H "Content-Type: application/json" \\
  -d '{
    "user_id": 101,
    "pin": "1234",
    "kyc_type": "VOTERID",
    "amount": "5",
    "epic_number": "XYZ1234567"
  }'`,
    params: [
      { name: "epic_number", type: "string", req: "required" }
    ]
  },
  {
    title: "PASSPORT",
    curl: `curl -X POST "https://yourdomain.com/api/kyc-verify/" \\
  -H "Content-Type: application/json" \\
  -d '{
    "user_id": 101,
    "pin": "1234",
    "kyc_type": "PASSPORT",
    "amount": "20",
    "passport_number": "A1234567",
    "dob": "1990-01-15"
  }'`,
    params: [
      { name: "passport_number", type: "string", req: "required" },
      { name: "dob", type: "string YYYY-MM-DD", req: "required" }
    ]
  },
  {
    title: "VEHICLE_RC",
    curl: `curl -X POST "https://yourdomain.com/api/kyc-verify/" \\
  -H "Content-Type: application/json" \\
  -d '{
    "user_id": 101,
    "pin": "1234",
    "kyc_type": "VEHICLE_RC",
    "amount": "10",
    "registration_number": "DL3CA1234"
  }'`,
    params: [
      { name: "registration_number", type: "string", req: "required" }
    ]
  },
  {
    title: "FACE_MATCH",
    curl: `curl -X POST "https://yourdomain.com/api/kyc-verify/" \\
  -H "Content-Type: multipart/form-data" \\
  -F "user_id=101" \\
  -F "pin=1234" \\
  -F "kyc_type=FACE_MATCH" \\
  -F "amount=15" \\
  -F "image1=@/path/to/selfie.jpg" \\
  -F "image2=@/path/to/pan_photo.jpg"`,
    params: [
      { name: "image1", type: "file", req: "required" },
      { name: "image2", type: "file", req: "required" }
    ]
  },
  {
    title: "MOBILE_PENNYDROP",
    curl: `curl -X POST "https://yourdomain.com/api/kyc-verify/" \\
  -H "Content-Type: application/json" \\
  -d '{
    "user_id": 101,
    "pin": "1234",
    "kyc_type": "MOBILE_PENNYDROP",
    "amount": "5",
    "mobile_number": "9876543210",
    "upi_id": "9876543210@paytm"
  }'`,
    params: [
      { name: "mobile_number", type: "string", req: "required" },
      { name: "upi_id", type: "string", req: "optional" }
    ]
  },
  {
    title: "AADHAAR_MASKING",
    curl: `curl -X POST "https://yourdomain.com/api/kyc-verify/" \\
  -H "Content-Type: multipart/form-data" \\
  -F "user_id=101" \\
  -F "pin=1234" \\
  -F "kyc_type=AADHAAR_MASKING" \\
  -F "amount=10" \\
  -F "image=@/path/to/aadhaar.jpg"`,
    params: [
      { name: "image", type: "file", req: "required" }
    ]
  }
];

function KYCPage() {
  return (
    <div>
      <div style={{ marginBottom: 24, paddingBottom: 16, borderBottom: "0.5px solid #e2e8f0" }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 4, color: "#0f172a" }}>KYC Verification API</h2>
        <p style={{ fontSize: 13, color: "#64748b" }}>Perform real-time KYC, bank account verification, Aadhaar OTP verification, and more.</p>
        <BaseUrl method="POST" path="kyc_verification" />
      </div>

      <SectionLabel style={{ marginTop: 0 }}>Supported KYC Types & Descriptions</SectionLabel>
      <div style={{ border: "0.5px solid #e2e8f0", borderRadius: 10, overflow: "hidden", marginBottom: 24 }}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={{ ...styles.th, width: "35%" }}>KYC Type</th>
              <th style={styles.th}>Description</th>
            </tr>
          </thead>
          <tbody>
            {KYC_TYPES.map((item, idx) => (
              <tr key={idx}>
                <td style={{ ...styles.td, fontFamily: "monospace", color: "#3C3489", fontWeight: 600 }}>{item.type}</td>
                <td style={{ ...styles.td, color: "#374151" }}>{item.desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <SectionLabel>Common Parameters (All KYC Types)</SectionLabel>
      <div style={{ border: "0.5px solid #e2e8f0", borderRadius: 10, overflow: "hidden", marginBottom: 24 }}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Parameter</th>
              <th style={styles.th}>Type</th>
              <th style={styles.th}>Required</th>
              <th style={styles.th}>Description</th>
            </tr>
          </thead>
          <tbody>
            <ParamRow name="user_id"        type="integer" required desc="User account ID" />
            <ParamRow name="pin"            type="string"  required desc="Transaction PIN" />
            <ParamRow name="kyc_type"       type="string"  required desc="One of the supported types above (e.g. PANCARD, AADHAAR)" />
            <ParamRow name="amount"         type="float"   required desc="Charge per verification" />
          </tbody>
        </table>
      </div>

      <SectionLabel>KYC Failure / Error Responses</SectionLabel>
      <div style={{ border: "0.5px solid #e2e8f0", borderRadius: 10, overflow: "hidden", marginBottom: 24 }}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={{ ...styles.th, width: "35%" }}>Scenario / Message</th>
              <th style={styles.th}>JSON Response</th>
            </tr>
          </thead>
          <tbody>
            {[
              { msg: "KYC Verification Failed", json: `{ "message": "KYC Verification Failed", "status": false, "reference_num": "1234567890" }` },
              { msg: "KYC Verification Pending", json: `{ "message": "KYC Verification Pending. Please wait.", "status": false, "reference_num": "1234567890" }` },
              { msg: "Low Wallet Balance", json: `{ "message": "Low balance, kindly recharge your wallet", "status": false, "reference_num": "" }` },
              { msg: "Incorrect Transaction PIN", json: `{ "message": "Transaction PIN is incorrect", "status": false, "reference_num": "" }` },
              { msg: "Account Blocked", json: `{ "message": "Your account has been blocked", "status": false, "reference_num": "" }` },
              { msg: "KYC Provider Down", json: `{ "message": "KYC Provider is currently down!", "status": false, "reference_num": "" }` },
              { msg: "KYC Service Down", json: `{ "message": "KYC Service is currently down!", "status": false, "reference_num": "" }` },
              { msg: "Duplicate Request", json: `{ "message": "Duplicate request. Please try after 5 minutes.", "status": false }` },
              { msg: "Invalid Scheme", json: `{ "message": "Invalid scheme. Please contact your admin.", "status": false, "reference_num": "" }` },
              { msg: "Invalid KYC Type", json: `{ "message": "Invalid KYC type. Supported: PANCARD, AADHAAR, ...", "status": false, "reference_num": "" }` },
              { msg: "KYC Service Offline", json: `{ "message": "KYC service is down!", "status": false, "reference_num": "1234567890" }` }
            ].map((err, idx) => (
              <tr key={idx}>
                <td style={styles.td}>
                  <div style={{ fontWeight: 600, color: "#A32D2D" }}>{err.msg}</div>
                </td>
                <td style={styles.td}>
                  <pre style={{
                    margin: 0,
                    background: "#FCEBEB15",
                    border: "0.5px solid #FCEBEB",
                    borderRadius: 6,
                    padding: "6px 10px",
                    fontFamily: "monospace",
                    fontSize: 11,
                    color: "#A32D2D",
                    whiteSpace: "pre-wrap"
                  }}>{err.json}</pre>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <SectionLabel>KYC Types Specific Specifications</SectionLabel>
      
      {KYC_SECTIONS.map((section, sIdx) => (
        <div key={sIdx} style={{ background: "#fff", border: "0.5px solid #e2e8f0", borderRadius: 10, padding: 18, marginBottom: 24 }}>
          <h3 style={{ fontSize: 15, fontWeight: 600, color: "#0f172a", marginBottom: 8, borderBottom: "0.5px solid #f1f5f9", paddingBottom: 6 }}>
            {section.title}
          </h3>
          
          <div style={{ margin: "12px 0" }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: ".03em" }}>cURL Request Example</span>
            <CodeBlock code={section.curl} />
          </div>

          <div style={{ marginTop: 14 }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: ".03em", display: "block", marginBottom: 6 }}>Specific Parameters</span>
            <div style={{ border: "0.5px solid #e2e8f0", borderRadius: 8, overflow: "hidden", marginBottom: 16 }}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Field</th>
                    <th style={styles.th}>Type</th>
                    <th style={styles.th}>Required</th>
                  </tr>
                </thead>
                <tbody>
                  {section.params.map((p, pIdx) => (
                    <tr key={pIdx}>
                      <td style={styles.td}>
                        <span style={{ fontFamily: "monospace", fontSize: 12, color: "#185FA5", fontWeight: 600 }}>{p.name}</span>
                      </td>
                      <td style={styles.td}>
                        <span style={{ color: "#64748b", fontFamily: "monospace" }}>{p.type}</span>
                      </td>
                      <td style={styles.td}>
                        {p.req === "required" ? (
                          <span style={{ color: "#3B6D11", fontWeight: 600 }}>✅</span>
                        ) : (
                          <span style={{ color: "#5F5E5A", fontSize: 11 }}>⚪ Optional</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div style={{ marginTop: 16 }}>
            <TabPanel tabs={[
              {
                label: "Success Response",
                content: (
                  <div style={{ marginTop: 8 }}>
                    <div style={{ background: "#EAF3DE", borderLeft: "3px solid #639922", padding: "8px 12px", fontSize: 12, color: "#3B6D11", marginBottom: 10 }}>status: true</div>
                    <CodeBlock code={`{
  "message": "KYC Verification Successful",
  "status": true,
  "reference_num": "1234567890",
  "data": {
    "status": "SUCCESS",
    "reference_id": "CF_REF_123",
    "pan": "ABCDE1234F",
    "name": "John Doe"
  }
}`} />
                  </div>
                )
              },
              {
                label: "Failure Responses",
                content: (
                  <div style={{ marginTop: 8 }}>
                    <div style={{ background: "#FCEBEB", borderLeft: "3px solid #E24B4A", padding: "8px 12px", fontSize: 12, color: "#A32D2D", marginBottom: 10 }}>status: false</div>
                    <CodeBlock code={`// 1. Verification Failed
{
  "message": "KYC Verification Failed",
  "status": false,
  "reference_num": "1234567890"
}

// 2. Verification Pending
{
  "message": "KYC Verification Pending. Please wait.",
  "status": false,
  "reference_num": "1234567890"
}

// 3. Low Wallet Balance
{
  "message": "Low balance, kindly recharge your wallet",
  "status": false,
  "reference_num": ""
}

// 4. Incorrect PIN
{
  "message": "Transaction PIN is incorrect",
  "status": false,
  "reference_num": ""
}

// 5. Account Blocked
{
  "message": "Your account has been blocked",
  "status": false,
  "reference_num": ""
}

// 6. Provider Down
{
  "message": "KYC Provider is currently down!",
  "status": false,
  "reference_num": ""
}

// 7. Service Down
{
  "message": "KYC Service is currently down!",
  "status": false,
  "reference_num": ""
}

// 8. Duplicate Request
{
  "message": "Duplicate request. Please try after 5 minutes.",
  "status": false
}

// 9. Invalid Scheme
{
  "message": "Invalid scheme. Please contact your admin.",
  "status": false,
  "reference_num": ""
}

// 10. Invalid KYC Type
{
  "message": "Invalid KYC type. Supported: PANCARD, AADHAAR, ...",
  "status": false,
  "reference_num": ""
}`} />
                  </div>
                )
              }
            ]} />
          </div>
        </div>
      ))}
    </div>
  );
}

// ── Main App ──────────────────────────────────────────────────────────────────
const PAGE_MAP = {
  operators: <OperatorsPage />,
  auth:      <AuthPage />,
  recharge:  <RechargePage />,
  status:    <StatusPage />,
  balance:   <BalancePage />,
  callback:  <CallbackPage />,
  kyc:       <KYCPage />,
};

export default function RechargeAPIDocs() {
  const [activePage, setActivePage] = useState("operators");
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <main>
      <div className="container-fluid">
    <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", background: "#f1f5f9", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=DM+Mono:wght@400;500&display=swap" rel="stylesheet" />

      {/* Top bar */}
      <div style={{
        background: "#fff", borderBottom: "0.5px solid #e2e8f0",
        padding: "12px 20px", display: "flex", alignItems: "center", gap: 16,
        position: "sticky", top: 0, zIndex: 100,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{
            width: 32, height: 32, borderRadius: 8,
            background: "#185FA5", display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <span style={{ color: "#fff", fontSize: 14, fontWeight: 700 }}>R</span>
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 600, color: "#0f172a" }}>Recharge API</div>
            <div style={{ fontSize: 11, color: "#94a3b8" }}>api.mokshiq.in · v1.0</div>
          </div>
        </div>
        <div style={{
          marginLeft: "auto", display: "flex", alignItems: "center", gap: 8,
          background: "#f8fafc", border: "0.5px solid #e2e8f0",
          borderRadius: 8, padding: "6px 12px",
          fontFamily: "monospace", fontSize: 11, color: "#64748b",
        }}>
          <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#3B6D11", display: "inline-block" }} />
          https://api.mokshiq.in
        </div>
      </div>

      <div style={{ display: "flex", flex: 1 }}>
        {/* Sidebar */}
        <div style={{
          width: 220, flexShrink: 0,
          background: "#fff", borderRight: "0.5px solid #e2e8f0",
          padding: "16px 0", position: "sticky", top: 57,
          height: "calc(100vh - 57px)", overflowY: "auto",
        }}>
          {NAV_ITEMS.map((item, i) => (
            <React.Fragment key={item.id}>
              {item.section && (
                <div style={{
                  padding: "12px 16px 4px",
                  fontSize: 10, fontWeight: 600, letterSpacing: ".08em",
                  textTransform: "uppercase", color: "#94a3b8",
                }}>
                  {item.section}
                </div>
              )}
              <div
                onClick={() => setActivePage(item.id)}
                style={{
                  display: "flex", alignItems: "center", gap: 9,
                  padding: "9px 16px", cursor: "pointer",
                  borderLeft: `2px solid ${activePage === item.id ? item.color : "transparent"}`,
                  background: activePage === item.id ? `${item.color}10` : "transparent",
                  color: activePage === item.id ? item.color : "#64748b",
                  fontWeight: activePage === item.id ? 600 : 400,
                  fontSize: 13,
                  transition: "all .15s",
                }}
              >
                <span style={{
                  width: 7, height: 7, borderRadius: "50%",
                  background: item.color, flexShrink: 0,
                  opacity: activePage === item.id ? 1 : 0.4,
                }} />
                {item.label}
              </div>
            </React.Fragment>
          ))}
        </div>

        {/* Main content */}
        <div style={{ flex: 1, padding: "28px 32px", maxWidth: 860 }}>
          {PAGE_MAP[activePage]}
        </div>
      </div>
    </div>
    </div>
    </main>
  );
}